import { Inject, Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { SubjectObliged, SubjectObligedBasic } from '../models/subject-obliged';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ServicesHelper } from '../helpers/services.helper';

@Injectable()
export class SubjectObligedService extends BaseService<SubjectObliged> {
  constructor(httpClient: HttpClient, @Inject('API_URL') apiUrl: string) {
    const url: string = apiUrl + 'subject-obliged/';
    super(apiUrl, url, httpClient);
  }

  getCurrent(): Observable<SubjectObliged> {
    const url = this.url + 'current';
    const response: Observable<SubjectObliged> = this.httpClient.get<SubjectObliged>(url);
    return response;
  }

  public getSubjectObligeds(): Observable<Array<SubjectObligedBasic>> {
    const url = this.url + 'office-list';
    const response: Observable<Array<SubjectObligedBasic>> = this.httpClient.get<Array<SubjectObligedBasic>>(url, {
      responseType: 'json',
      headers: ServicesHelper.getHeaders(),
    });
    return response;
  }

  public getSubjectObligedsBranchOffices(): Observable<Array<SubjectObligedBasic>> {
    const url = this.url + 'office-list-branch-offices';
    const response: Observable<Array<SubjectObligedBasic>> = this.httpClient.get<Array<SubjectObligedBasic>>(url, {
      responseType: 'json',
      headers: ServicesHelper.getHeaders(),
    });
    return response;
  }

  getZoomLink(): Observable<string> {
    const url: string = this.url + 'zoom-link';
    const response: Observable<string> = this.httpClient.get<string>(url);
    return response;
  }

  public hasBeneficiaryDownloadEnabled(): Observable<boolean> {
    const url = this.url + 'final-beneficiary-enabled';
    const response = this.httpClient.get<boolean>(url);
    return response;
  }

  public isFica(): Observable<boolean> {
    const url = this.url + 'is-fica';
    const response = this.httpClient.get<boolean>(url, {
      responseType: 'json',
      headers: ServicesHelper.getHeaders(),
    });
    return response;
  }
}
